import { resolvePowSolution as e } from "../phone/runPhoneOtpSend.mjs";
import { useMutation as t } from "@maat/store-hooks";
import { usersApi as n } from "@maat/api-main";
//#region src/passkeys/usePasskeyStepUpMutations.ts
var r = (r) => ({
	options: t({
		mutationFn: async (t) => {
			let i = await e(r);
			return n.passkeyStepUpOptions({
				...t,
				...i ? { pow_solution: i } : {}
			});
		},
		retry: !1
	}),
	complete: t({
		mutationFn: n.passkeyStepUpComplete,
		retry: !1
	})
});
//#endregion
export { r as usePasskeyStepUpMutations };
